import { type FunctionComponent } from 'react';
import { Cell, Stub } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';

export type CellExpandStubProps = TestProps & {
    leftPadding?: boolean;
};

export const CellExpandStub: FunctionComponent<CellExpandStubProps> = ({
    'data-testid': dataTestId = 'CellExpandStub',
    leftPadding = false,
}) => (
    <Cell type="Checkbox" size="m" data-testid={dataTestId} leftPadding={leftPadding} rightPadding={false}>
        <Stub height={16} width={16} />
    </Cell>
);
